// import { useCallback, useEffect, useState } from "react"

import ContentLoader from 'react-content-loader'
import { useSelector } from 'react-redux'
import { RootState } from 'store/modules/rootReducer'
import FavoriteCoursesList from '../FavoriteCoursesList'
import SubscriptionCoursesList from '../SubscriptionCoursesList'
import { Container } from './styles'
import { useSubscriptionParams } from 'pages/Subscription/hooks/use-subscription-params'
import { useGetFavoriteCourses } from 'pages/Subscription/hooks/use-get-favorite-courses'
import { useMemo } from 'react'
import CampaignBanners from 'components/CampaignBanners'

const SubscriptionContent: React.FC = () => {
  const { subscriptionId } = useSubscriptionParams()
  const { isDarkMode } = useSelector((state: RootState) => state.theme)

  const LoaderProps = {
    speed: 2,
    backgroundColor: isDarkMode ? '#222222' : '#bababa',
    foregroundColor: isDarkMode ? '#2b2b2b' : '#dedede',
    width: '100%',
    height: '100%',
    viewBox: '0 0 160 40',
  }

  const swr = useGetFavoriteCourses(subscriptionId)

  const favoriteCoursesId = useMemo(() => swr.data?.map((course) => course._id), [swr.data])

  const banners = {
    link: 'https://studentarea-assets-dist.direcaoconcursos.com.br/student/document/DESAFIO_DIRECAO_PLANNER-21-DIAS.pdf',
    large_image:
      'https://studentarea-assets-dist.direcaoconcursos.com.br/student/image/pe_desafio_21_dias_large.jpg',
    medium_image:
      'https://studentarea-assets-dist.direcaoconcursos.com.br/student/image/pe_desafio_21_dias_medium.jpg',
    small_image:
      'https://studentarea-assets-dist.direcaoconcursos.com.br/student/image/pe_desafio_21_dias_small.jpg',
    name: 'Planner Desafio 21 dias - Direção Concursos',
  }

  return (
    <Container>
      {subscriptionId === '6508669d8c225c0033a6ee26' ? <CampaignBanners banner={banners} /> : <></>}
      {swr.isLoading ? (
        <ContentLoader {...LoaderProps}>
          <rect x="1" y="1" rx="0.5" ry="0.5" width="8rem" height="5rem" />
        </ContentLoader>
      ) : (
        <FavoriteCoursesList favoriteCourses={swr.data} subscriptionId={subscriptionId} />
      )}
      <SubscriptionCoursesList favoriteCoursesId={favoriteCoursesId} />
    </Container>
  )
}

export default SubscriptionContent
